export default __webpack_public_path__ + "static/jonnnyAvatar-04d11124568b574699a23b8057926fe1.png";